// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consumption-per-product {
  position: relative; /* Ensure child elements are positioned relative to this container */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid white;
  padding: 1rem;
  gap: 1rem;
}
.consumption-per-product__selectors {
  height: 5%;
}
.consumption-per-product__preview-table {
  height: 50vh;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 101;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/consumption-per-product/consumption-per-product.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA,EAAA,oEAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AACJ;AAAI;EACI,UAAA;AAER;AAAI;EACI,YAAA;AAER;;AAEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AACJ;;AAEA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;AACJ","sourcesContent":[".consumption-per-product {\n    position: relative; /* Ensure child elements are positioned relative to this container */\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    border: 1px solid white;\n    padding: 1rem;\n    gap: 1rem;\n    &__selectors{\n        height: 5%;\n    }\n    &__preview-table{\n        height: 50vh;\n    }\n}\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 101;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
